import { render, staticRenderFns } from "./AdminProfileContainer.vue?vue&type=template&id=52c3db7b&"
import script from "./AdminProfileContainer.vue?vue&type=script&lang=js&"
export * from "./AdminProfileContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports